<h2 id="team-assessment-heading" class="flex-align-center grid-gap-1"><fa-icon [icon]="faFire" aria-label="UPDATE YOUR PROFILE"></fa-icon>
<span class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">TEAM ASSIGNMENTS - ACTIVE ({{report_count}})</span>
</h2>
<table mat-table [dataSource]="reports" class="center" multiTemplateDataRows
  aria-labelledby="team-assessment-heading team-assessment-caption">
  <caption id="team-assessment-caption" class="usa-sr-only">
    Team Assignments - Active. Columns: Fire/Complex/Report Name, Report ID, Forest Name, Skills,
    Tentative Start Date - Close-out Date, Action.
  </caption>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Fire/Complex/Report Name</th>
    <td mat-cell *matCellDef="let report"><a [routerLink]="'/fire-overview'"
    [queryParams]="{assessment_id: report.assessment_id}">{{report.assessment.baer_name}}({{report.report_num}})</a>
  </td>
</ng-container>
<ng-container matColumnDef="reportId">
  <th mat-header-cell *matHeaderCellDef>Report ID</th>
  <td mat-cell *matCellDef="let report" class="prewrap">{{report.report_id}}</td>
</ng-container>
<ng-container matColumnDef="forest_name">
  <th mat-header-cell *matHeaderCellDef>Forest Name</th>
  <td mat-cell *matCellDef="let report" class="prewrap">{{report.assessment.forest_name | forest_filter |
  line_break}}</td>
</ng-container>
<ng-container matColumnDef="skills">
  <th mat-header-cell *matHeaderCellDef>Skills</th>
  <td mat-cell *matCellDef="let report">
    @if (report.users[0].skills.length != 0) {
      <mat-chip class="chip"
      >{{report.users[0].skills[0].skill.text}}</mat-chip>
    } @else {
      --
    }
    @if (report.users[0].skills.length > 1) {
      <mat-chip class="chip" style="margin-left: 5px;"
        [matTooltip]='report.tooltip' matTooltipClass="tooltipClass">
        +{{report.users[0].skills.length - 1}}
      </mat-chip>
    }
  </td>
</ng-container>
<ng-container matColumnDef="date">
  <th mat-header-cell *matHeaderCellDef>Tentative Start Date - Close-out Date</th>
  <td mat-cell *matCellDef="let report" class="prewrap">{{(report.assessment.tentative_start_week | date:"MM/dd/yyyy") ||
  "N/A"}} - {{(report.assessment.close_out_date | date:"MM/dd/yyyy") || "N/A"}}</td>
</ng-container>
<ng-container matColumnDef="action">
  <th mat-header-cell *matHeaderCellDef style="width: 270px;">Action</th>
  <td mat-cell *matCellDef="let report" style="width: 270px;">
    <div class="action-div">
      <button class="btn-only" [routerLink]="'/fire-overview'"
        [queryParams]="{assessment_id: report.assessment_id}">
        <mat-icon>visibility</mat-icon>View Fire Overview
      </button>
    </div>
  </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>

<!-- Row shown when there is no matching data. -->
<tr class="mat-row" *matNoDataRow>
  <td class="mat-cell" colspan="13">
    <div class="no-data">
      <div class="no-data-icon">
        <mat-icon class="no-data-icon1">search</mat-icon>
        <fa-icon [icon]="faFire" class="no-data-icon2"></fa-icon>
      </div>
      <div class="no-data-title">No Team Assignments</div>
      <p>You haven't been assigned to an assessment yet</p>
    </div>
  </td>
</tr>
</table>

<button aria-label="View All" class="usa-button usa-button--secondary view-all" [routerLink]="'/user'" fragment="assignments">View All<fa-icon
[icon]="faChevronRight" aria-label="View All"></fa-icon></button>
